"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCronitor = void 0;
const Cronitor = __importStar(require("@cronitorio/cronitor-rum-js"));
const router_1 = require("next/router");
const react_1 = require("react");
/**
 * React hook for automatically tracking navigation changes on Next.js apps.
 *
 * @param clientKey the client key for the Cronitor site.
 * @param config the Cronitor tracker configuration object.
 */
const useCronitor = (clientKey, config = {}) => {
    const router = (0, router_1.useRouter)();
    (0, react_1.useEffect)(() => {
        Cronitor.load(clientKey, config);
        // Trigger initial page view
        Cronitor.track('Pageview');
        // Add on route change handler for client-side navigation
        const handleRouteChange = () => Cronitor.track('Pageview');
        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [clientKey]);
    return Cronitor;
};
exports.useCronitor = useCronitor;
//# sourceMappingURL=index.js.map